export const CHAT_STATE = 'chat'
export const CHAT_INIT = 'chat/INIT'
export const CHAT_RESET = 'chat/CHAT_RESET'
export const SET_MESSAGE = 'chat/SET_MESSAGE'
export const SET_DISCONNECT = 'chat/SET_DISCONNECT'
